var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Animation_icon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Animation_icon_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 1.5a5 5 0 100-10 5 5 0 000 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.297 10.297A5.002 5.002 0 009 20a5.002 5.002 0 004.703-3.297 4.989 4.989 0 01-1.83.295 3.5 3.5 0 11-4.872-4.872 4.99 4.99 0 01.296-1.829z",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.297 7.297A5.002 5.002 0 0012 17a5.002 5.002 0 004.703-3.297 4.989 4.989 0 01-1.83.295 3.5 3.5 0 11-4.872-4.872 4.99 4.99 0 01.296-1.829z",
    fillOpacity: 0.65
  }))));
}
export default SvgAnimationIcon;